<template>
	<v-container
		fluid
	>

		<v-row>
			<v-col>
				<v-card class="mb-6">
					<v-card-title>Resumen consolidado de ventas</v-card-title>
					<div class="d-flex">
						<v-simple-table>
							<template v-slot:default>
								<tbody>
									<tr>
										<td>Total de ventas hoy:</td>
										<td>{{ moneda(hoy.montoTotal) }}</td>
									</tr>
									<tr>
										<td>Total de ventas este mes:</td>
										<td>{{ moneda(esteMes.montoTotal) }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
						<v-spacer></v-spacer>
					</div>
				</v-card>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" sm="6">
				<resumen-ventas-periodo hoy @input="hoy = $event"></resumen-ventas-periodo>
			</v-col>
			<v-col cols="12" sm="6">
				<resumen-ventas-periodo modo="día" predeterminado="ayer"></resumen-ventas-periodo>
			</v-col>
		</v-row>

		<v-row>
			<v-col cols="12" sm="6">
				<resumen-ventas-periodo este-mes @input="esteMes = $event"></resumen-ventas-periodo>
			</v-col>
			<v-col cols="12" sm="6">
				<resumen-ventas-periodo predeterminado="el-mes-pasado"></resumen-ventas-periodo>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
import { número, moneda } from '@/../../cliente_comun/utilidades'
import ResumenVentasPeriodo from '@/components/resumenVentasPeriodo.vue'

export default {
	name: 'Tablero',
  data: () => ({
		hoy: {
			montoTotal: 0,
			productosÚnicos: []
		},
		esteMes: {
			montoTotal: 0,
			productosÚnicos: []
		},
	}),
	components: {
		ResumenVentasPeriodo,
	},
	methods: {
		número,
		moneda,
	}
}
</script>